export default __webpack_public_path__ + "static/media/falseNoGrass.17c593a8.png";